import React from "react";
import { observer } from "mobx-react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

const CODE_PATTERN = /^\d{6}$/;

const ConfirmaitonCodeInput = observer(({ setIsActive, setValue }) => {
    const { t } = useTranslation();

    const handleCodeChange = (e) => {
        const next = e.target.value;
        setValue(next);
        setIsActive(CODE_PATTERN.test(next));
    };

    return (
        <Input
            type="number"
            size="large"
            inputMode="numeric"
            autoComplete="one-time-code"
            onChange={handleCodeChange}
            placeholder={t("form.confirmationCode")}
            className="w-[313px] [&_input::-webkit-inner-spin-button]:appearance-none"
            style={{ height: 61 }}
            maxLength={6}
        />
    );
});

export default ConfirmaitonCodeInput;
